import { IGuest_EventNew } from '@bridebook/models/source/models/Weddings/Guests.types';
import {
  addedGuestAnalytics,
  addedMultipleGuestsAnalytics,
  clickedAddGuestsAnalytics,
  clickedToShareGuestCollectorLinkAnalytics,
  initialisedGuestlistAnalytics,
  interactedWithGuestsOnGuestlistAnalytics,
  sharedGuestCollectorLinkAnalytics,
  toggleBulkAddGuestsMethodAnalytics,
} from '@bridebook/web/lib/guestlist/analytics/actions';

export enum GuestlistAnalyticsActionTypes {
  INITIALISED_GUESTLIST = '[Analytics] Guestlist initialised',
  TOGGLE_BULK_ADD_METHOD = '[Analytics] Toggle bulk add guests method',
  CLICKED_ADD_GUESTS = '[Analytics] Clicked to add guests',
  ADDED_MULTIPLE_GUESTS = '[Analytics] Added multiple guests',
  OPENED_GUEST_COLLECTOR_POPUP = '[Analytics] Opened guest collector popup',
  CLOSED_GUEST_COLLECTOR_POPUP = '[Analytics] Closed guest collector popup',
  CLICKED_TO_SHARE_GUEST_COLLECTOR_LINK = '[Analytics] Clicked to share guest collector link',
  SHARED_GUEST_COLLECTOR_LINK = '[Analytics] Shared guest collector link',
  INTERACTED_WITH_GUESTS_ON_GUESTLIST = '[Analytics] Interacted with guests on guestlist',
}

export type AddedMultipleGuestsAnalyticsAction = ReturnType<typeof addedMultipleGuestsAnalytics>;

export type AddedGuestAnalyticsAction = ReturnType<typeof addedGuestAnalytics>;

export type InitialisedGuestlistAnalyticsAction = ReturnType<typeof initialisedGuestlistAnalytics>;

export type ToggleBulkAddGuestsMethodAnalyticsAction = ReturnType<
  typeof toggleBulkAddGuestsMethodAnalytics
>;

export type ClickedAddGuestsAnalyticsAction = ReturnType<typeof clickedAddGuestsAnalytics>;

export type SharedGuestCollectorLinkAnalyticsAction = ReturnType<
  typeof sharedGuestCollectorLinkAnalytics
>;

export type InteractedWithGuestsOnGuestlistAnalyticsAction = ReturnType<
  typeof interactedWithGuestsOnGuestlistAnalytics
>;

export interface InteractedWithGuestsOnGuestlistAnalyticsPayload {
  guestAction: 'added' | 'deleted' | 'edited' | 'clicked';
  guestMethod: 'popover' | 'missingEmailHyperlink' | 'emailHyperlink';
  guestCount?: number;
  guestGroupId?: string;
  guestGroupName?: string;
  guestId?: string;
  guestName?: string;
  guestInvitations?: Record<
    string,
    {
      type: 'mainEvent' | 'customEvent';
      invited: boolean;
      rsvp: IGuest_EventNew['rsvp'];
    }
  >;
  category?: string;
}

export type ClickedToShareGuestCollectorLinkAnalyticsAction = ReturnType<
  typeof clickedToShareGuestCollectorLinkAnalytics
>;

export interface ClickedToShareGuestCollectorLinkAnalyticsPayload {
  collectGuestInfoPopupLocation: 'guestInterior' | 'guestExterior' | 'guestList' | 'guestComms';
  elementLabel?: string;
  element?: string;
  section?: string;
  category?: string;
}
